define('bindingHandlers/scrolled',[
    'lib/knockout',
    'jquery',
], function (
    ko,
    $
) {
    'use strict';

    var EVENT_NAMESPACE = ".scrolled-evt";

    var isNearBottom = function (scrollPosition, element) {
        // Execute the callback when the scroll position is past the trigger
        // position.
        var tolerance = Math.min(element.scrollHeight * 0.3, 200);
        var triggerPosition = element.scrollHeight - element.offsetHeight - tolerance;

        return scrollPosition > triggerPosition;
    };

    /**
     * This binding handler hooks into the scroll event of an element and will trigger a
     * provided function callback whenever the attached element is about to approach the
     * _bottom_ of its container.
     *
     * The benefit of using this binding handler as opposed to accessing the raw scroll
     * event is that this abstracts away the DOM interaction and calculations used to
     * determine when to trigger the provided scroll event callbacks.
     *
     * **NOTE**: UX has final say as to whether or not an infinite scroll interaction
     * should be used in a view. This interaction is meant to be used for exceptional
     * cases where normal paging does not make sense.
     *
     * As of 8/5/14, this binding handler only supports
     *
     * ## Example
     *
     * <div data-bind="scrolled: myHandler"></div>
     *
     * ## Arguments
     *
     * @param {Function} bottomScrollCallback - The function to execute when the scroll
     *  position of the container is about to approach the bottom of said container.
     */
    ko.bindingHandlers.scrolled = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var $element = $(element);
            var scrollEventCallback = ko.unwrap(valueAccessor());

            $element.on("scroll" + EVENT_NAMESPACE, function (evt) {
                var currentScrollPosition = $element.scrollTop();

                if (isNearBottom(currentScrollPosition, element)) {
                    scrollEventCallback(bindingContext.$data, evt);
                }
            });

            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                $element.off(EVENT_NAMESPACE);
            });
        }
    };
});
